var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgIconTrash = function SvgIconTrash(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 14.4C1.6 14.8243 1.76857 15.2313 2.06863 15.5314C2.36869 15.8314 2.77565 16 3.2 16H11.2C11.6243 16 12.0313 15.8314 12.3314 15.5314C12.6314 15.2313 12.8 14.8243 12.8 14.4V4.8H14.4V3.2H11.2V1.6C11.2 1.17565 11.0314 0.768687 10.7314 0.468629C10.4313 0.168571 10.0243 0 9.6 0H4.8C4.37565 0 3.96869 0.168571 3.66863 0.468629C3.36857 0.768687 3.2 1.17565 3.2 1.6V3.2H0V4.8H1.6V14.4ZM4.8 1.6H9.6V3.2H4.8V1.6ZM4 4.8H11.2V14.4H3.2V4.8H4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80029 6.40002H6.40029V12.8H4.80029V6.40002ZM8.00029 6.40002H9.60029V12.8H8.00029V6.40002Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash.25686c3e.svg";
export { ForwardRef as ReactComponent };